<template>
  <section class='screen2'>
    <transition name='fade'>
        <div v-if='status == "resting"' class='resting'>
            <div class='background' :style="{backgroundImage: 'url('+require('../assets/img/background_h.png')+')'}"></div>
            <div class='intro'>
                <h1>Launch the interactive “Bionic Company” experience on the screen to your right</h1>
                <svg class='arrows' width="1080" height="352" viewBox="0 0 1080 352">
                    <path class='arr arr1' d="M-90.84,254.72l144,160A16.23,16.23,0,0,0,65.07,420h96A16,16,0,0,0,173,393.28L38.6,244,173,94.69A16,16,0,0,0,161.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0-90.84,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
                    <path class='arr arr2' d="M119.16,254.72l144,160A16.23,16.23,0,0,0,275.07,420h96A16,16,0,0,0,383,393.28L248.6,244,383,94.69A16,16,0,0,0,371.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0,119.16,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
                    <path class='arr arr3' d="M327.16,254.72l144,160A16.23,16.23,0,0,0,483.07,420h96A16,16,0,0,0,591,393.28L456.6,244,591,94.69A16,16,0,0,0,579.07,68h-96a16,16,0,0,0-11.91,5.32l-144,160A16,16,0,0,0,327.16,254.72Z" transform="translate(94.94 -68)" style="fill: #fff"/>
                </svg>
            </div> 
        </div>
    </transition>
    <transition name='fade'>
        <div v-if='status == "active"' class="vid_holder">
          <transition name='fade'>
            <div @click='playVideo()' v-if='!startVideo' class='text_holder'>
              <h1>Touch here to learn how digital can unlock massive value for organizations</h1>
              <div class='btn round_btn'>
                <div>
                  <img class='play' src='../assets/img/arr.svg'>
                </div>
              </div>
            </div>
          </transition>
            <transition name='fade'>
              <div @click='videoEnded()' class='skip'>
                <p>SKIP</p>
              </div>
            </transition>
            <video controls ref='video' @ended="videoEnded" src='https://firebasestorage.googleapis.com/v0/b/bcg-center.appspot.com/o/welcome.mp4?alt=media&token=cdb3d26f-0f53-44d6-b2bd-229b5a484262'></video>
        </div>
    </transition>
    <transition name='fade'>
      <step1 v-if='status == "step1"'></step1>
    </transition>
    <transition name='fade'>
      <step2 v-if='status == "step2"' :sector='sector'></step2>
    </transition>
  </section>
</template>

<script>
import Step1 from '@/components/steps/Step1.vue';
import Step2 from '@/components/steps/Step2.vue';
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "home",
  components: {
    'step1': Step1,
    'step2': Step2
  },
  data(){
    return {
      startVideo: false,
      sector: null,
      initial: false,
      status: "resting",
      play: false,
      activations: []
    }
  },
  created(){
    let vm = this;
    db.collection("activation")
    .orderBy('created', 'desc')
    .onSnapshot(function(doc) {
        vm.activations = doc.docs.map((obj) => {
          let data = obj.data();
          data.id = obj.id
          return data;
        });
    });
  },
  methods: {
    nextStep(step) {
      let vm = this;
      this.step = null;
      setTimeout(function(){
        vm.step = step;
        vm.animate();
      }, 1000);
    },
    videoEnded(){
      this.nextStep('step1');
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
    playVideo(){
      this.startVideo = true;
      this.$refs.video.play();
    },
    nextStep(step){
      let vm = this;
      this.status = null;
      setTimeout(()=>{
          vm.status = step;
          vm.sector = vm.activations[0].sector;
      }, 1000);
    },
    reset(){
      this.status = null;
      setTimeout(()=>{
          this.sessionComplete();
      }, 1000);
    },
    startOver(){
      this.nextStep('active')
    },
    sessionComplete(){
      let vm = this;
      this.activations[0].complete = true;
      db.collection('activation').doc(this.activations[0].id)
          .set(this.activations[0], {merge: true})
          .then(()=>{
            vm.status = 'resting';
          })
          .catch((err)=>{
            vm.status = 'resting';
          });
    }
  },
  watch: {
    activations(){
        let vm = this;
        if (this.initial) {
          if (!this.activations[0].complete) {
            this.nextStep('active');
          }
        }

        if (!moment(this.activations[0].created).isAfter(Date.now)){
            this.initial = true;
        }
    }
  }
}
</script>

<style lang="css">
</style>
